import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json'
	})
};

class Godown {
	godown_name:string;
	address:string;
	phone_no:string;
}

@Injectable()
export class GodownService {

	private url = environment.url;
	private godownUrl =  this.url + '/godown/all';
	public selected_godown:string=null;

	constructor(private http: HttpClient) { }

	addNewGodown(form): Observable<string>{
		return this.http.post<string>(this.url + '/godown/submit', form, http_options);
	}

	getGodownes(): Observable<Godown[]> {
		return this.http.get<Godown[]>(this.godownUrl);
	}
	getGodownMasterFormWith(name:string): Observable<Godown[]> 
	{
		console.log (this.http.get<Godown[]>(this.url + '/godown/get/' + name));
		return this.http.get<Godown[]>(this.url + '/godown/get/' + name);
	}
	// getSelectedGodown(godown:string){
	// 	this.selected_godown = godown;
	// 	console.log(this.selected_godown);
	// };
}




// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/_services/_masters/godown.service.ts